import React from 'react';

const SortIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19.554 8.6v12.267" stroke="#5A6474" strokeLinecap="round" />
    <path
      d="M23.423 17.426l-3.573 3.572a.457.457 0 01-.646 0l-3.569-3.567"
      stroke="#5A6474"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M.692 4.692H17.05M.692 10.338h11.431M.692 15.984h7.729"
      stroke="#5A6474"
      strokeLinecap="round"
    />
  </svg>
);

export default SortIcon;
